import { hydrateRoot } from 'react-dom/client';

import { Application } from 'shared/containers/Referrer/App';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from '../../../shared/types/referrer/store';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export function renderReferrerApplication(dependencies: IDependencies): void {
  const { store, context } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(rootElement, <Application context={context} reduxStore={store} />);
}
